import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  desktop: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  mobile: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  tablet: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  main: {
    [theme.breakpoints.up("sm")]: {},
  },
  last: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3),
      paddingBottom: "200px",
    },
  },
  grid: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 10,
  },
}));
